import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Field from "./inputField2";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import humanResource, { HRactions } from "../redux/redux";
import { UseHrApp } from "../utils/context";
import PositionedSnackbar from "./snackbar";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  p: 4,
};

export default function ApplyLeaveModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { Emtoken,setshow, settext, setseverity, show, text, severity } = UseHrApp();

  const formic = useFormik({
    initialValues: {
      startDate: "",
      endDate: "",
      leaveType: "",
      reason: "",
    },
    validate: (values) => {
      const errors = {};

      if (!values.startDate) {
        errors.startDate = "Required";
      }
      if (!values.endDate) {
        errors.endDate = "Required";
      }
      if (values.leaveType === "None") {
        errors.leaveType = "Select a type!";
      }

      return errors;
    },
    onSubmit: (values) => {
      RequestLeave();
      formic.resetForm();
    },
  });

  async function RequestLeave() {
    try {
      const res = await axios({
        url: "https://hr-app-api.onrender.com/leave/request",
        method: "POST",
        data: {
          reason: formic.values.reason,
          endDate: formic.values.endDate,
          startDate: formic.values.startDate,
          leaveType: formic.values.leaveType,
        },
        headers: {
          Authorization: `Bearer ${Emtoken}`,
        },
      });

      if (res?.data?.status) {
       settext('Leave submitted')
       setshow(true)
       setseverity('success')
       handleClose()
      }
    } catch (error) {
      settext('Leave not submitted')
      setshow(true)
      setseverity('error')
    }
  }

  return (
    <div>
      <button className="p-4  rounded-[4em] bg-[#9A6AFF]" onClick={handleOpen}>
        {" "}
        <p className="text-[#1E2029] font-medium">Apply Leave</p>
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <p className="font-[Archivo] mb-4">Apply Leave?</p>
          </Typography>
          <div>
            <form
              className=" flex flex-col h-full gap-5 "
              onSubmit={formic.handleSubmit}
            >
              <div className="flex flex-col w-full gap-4 lg:gap-2">
                <label for="leaveType">LeaveType</label>
                <select
                  id="leaveType"
                  name="leaveType"
                  className=" min-w-[80px] outline-none border-[#000]/25 border-[1px] px-3 py-2 rounded focus:border-[#AFDBF5]     text-black"
                  value={formic.values.department}
                  onChange={formic.handleChange}
                >
                  <option value="None">None</option>
                  <option value="BEAVEMENT">Bereavement</option>
                  <option value="CASUAL">Casual</option>
                  <option value="SICK">Sick</option>
                </select>
                {formic.errors.leaveType && (
                  <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                    *{formic.errors.leaveType}
                  </p>
                )}
              </div>

              <div className=" w-full flex justify-between gap-3">
                <div className=" w-full flex flex-col gap-3 lg:gap-2">
                  <label htmlFor="startDate" className=" text-base">
                    Start Date
                  </label>
                  <input
                    name="startDate"
                    type="date"
                    value={formic.values.startDate}
                    onChange={formic.handleChange}
                    className=" min-w-[80px] outline-none border-[#000]/25 border-[1px] px-3 py-1 rounded focus:border-[#AFDBF5]     text-black"
                  />
                  {formic.errors.startDate && (
                    <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                      *{formic.errors.startDate}
                    </p>
                  )}
                </div>

                <div className=" w-full flex flex-col gap-3 lg:gap-2">
                  <label htmlFor="endDate" className=" text-base">
                    End Date
                  </label>
                  <input
                    name="endDate"
                    type="date"
                    value={formic.values.endDate}
                    onChange={formic.handleChange}
                    className=" min-w-[80px] outline-none border-[#000]/25 border-[1px] px-3 py-1 rounded focus:border-[#AFDBF5]     text-black"
                  />
                  {formic.errors.endDate && (
                    <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                      *{formic.errors.endDate}
                    </p>
                  )}
                </div>
              </div>
              <div>
                <label htmlFor="reason">Reason</label>

                <textarea
                  name={"reason"}
                  placeholder={"Enter your reason"}
                  value={formic.values.reason}
                  id={"reason"}
                  onChange={formic.handleChange}
                  type={"text"}
                  className=" w-full h-[80px] mt-2 border-2 p-1"
                />
                {formic.errors.reason && (
                  <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                    *{formic.errors.reason}
                  </p>
                )}
              </div>

              <div className=" flex gap-4">
                <button className="w-full h-full p-2 fond-[Archivo] font-semibold ">
                  {" "}
                </button>
                <input
                  type="submit"
                  className="w-full h-full p-2 fond-[Archivo] font-semibold bg-[#9A6AFF]"
                  value={"Add"}
                />
              </div>
            </form>
          </div>
        </Box>

      </Modal>
              
      <PositionedSnackbar value={show} setshow={setshow} text={text} severity={severity}/>
    </div>
  );
}
